import { TableProps } from 'antd';
import React, { FC, ReactNode } from 'react';
import { useWindowResize } from 'hooks/use-window-resize';
import { getTableHeight } from 'utils/auto-table-height';
import { TemplateInsightBaseTable } from './template-insight-base-table';

interface Props<T = any> extends TableProps<T> {
  titleLabel?: string;
  isLoading?: boolean;
  renderEmpty: () => ReactNode;
}

export const AutoHeightTable: FC<Props> = (props) => {
  const { dataSource } = props;
  const { height: tableBodyHeight } = useWindowResize(getTableHeight, [
    dataSource?.length,
  ]);

  return (
    <TemplateInsightBaseTable {...props} tableBodyHeight={tableBodyHeight} />
  );
};
